import {ADD_INVOICE, SET_INVOICES, UPDATE_INVOICE} from '../actionTypes';
import {IFarmInputInvoice} from 'constants/interfaces';

export type InvoiceState = {lastUpdate: number; invoices: IFarmInputInvoice[]};
const initialState: InvoiceState = {lastUpdate: 0, invoices: []};

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_INVOICES: {
      const invoices: IFarmInputInvoice[] = action.payload || [];
      const stateUpdate: InvoiceState = {
        lastUpdate: new Date().getTime(),
        invoices: invoices.map((invoice) => ({...invoice})),
      };
      return stateUpdate;
    }

    case UPDATE_INVOICE: {
      const invoiceUpdate: IFarmInputInvoice = action.payload;
      if (!invoiceUpdate) return state;

      const stateUpdate: InvoiceState = {
        lastUpdate: state.lastUpdate,
        invoices: state.invoices.map((invoice) => {
          if (invoice.id === invoiceUpdate.id) return {...invoiceUpdate};
          return invoice;
        }),
      };
      return stateUpdate;
    }

    case ADD_INVOICE: {
      const invoice: IFarmInputInvoice = action.payload;
      if (!invoice) return state;
      const stateUpdate: InvoiceState = {
        lastUpdate: state.lastUpdate,
        invoices: [invoice, ...state.invoices],
      };
      return stateUpdate;
    }

    default:
      return state;
  }
}
